export const QUANTITY_SPINNER_UP = (
  <svg width="5" height="5" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.762915 0.684175C1.3134 -0.228062 2.63636 -0.228061 3.18684 0.684176L3.74406 1.60757C4.31337 2.55099 3.63399 3.75446 2.5321 3.75446H1.41766C0.31577 3.75446 -0.363614 2.55099 0.205695 1.60757L0.762915 0.684175Z"
      fill="#ADB3C4"
    />
  </svg>
);

export const QUANTITY_SPINNER_DOWN = (
  <svg width="5" height="5" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.18679 3.07022C2.6363 3.98246 1.31335 3.98246 0.762862 3.07022L0.205643 2.14683C-0.363667 1.2034 0.315718 -6.90993e-05 1.41761 -6.90072e-05L2.53205 -6.89139e-05C3.63394 -6.88218e-05 4.31332 1.2034 3.74401 2.14683L3.18679 3.07022Z"
      fill="#ADB3C4"
    />
  </svg>
);
